<template>
  <div class="preview_item col-xl-3 col-lg-4 col-sm-6 mb-3">
    <img :src="item.src" class="img-fluid" />
    <div class="remove" v-on:click="removeItem(item.id)" v-if="item.completed">
      <i class="fas fa-times-circle"></i>
    </div>
    <div class="remove" v-else v-on:click="cancelUpload(item)">
      <i class="fas fa-times-circle"></i>
    </div>
    <div class="progress_info" v-if="item.progress<100">
      <div class="content">
        <div class="progress_overlay"></div>
        <div class="progress" style="height:12px">
          <div
            class="progress-bar bg-info"
            role="progressbar"
            :style="progressCompleted"
            :aria-valuenow="item.progress"
            aria-valuemin="0"
            aria-valuemax="100"
          >{{ item.progress }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    progressCompleted() {
      return "width:" + this.item.progress + "%;";
    }
  },
  methods: {
    removeItem(id) {
      this.$emit("removeItem", id);
      //console.log(id);
    },
    cancelUpload() {
      this.$emit("cancelUpload", this.item);
    }
  }
};
</script>

<style scoped>
.preview_item {
  overflow: hidden;
  max-height: 180px;
  margin-bottom: 5px;
  position: relative; 
}

.preview_item .img {
  max-height: 100%;
  width: auto;
}

.preview_item .remove {
  position: absolute;
  top: 20px;
  right: 50%;
  width: 40px;
  margin-right: -20px;
  font-size: 2.5em;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.3s ease-in;
  opacity: 0;
  z-index: 100;
}
.preview_item:hover .remove {
  opacity: 1;
}

.progress_info {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.progress_info .content {
  position: relative;
  width: 100%;
  height: 100%;
}

.progress_info .progress_overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  opacity: 0.5;
  z-index: 5;
}

.progress_info .content .progress {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 10;
}
</style>